import React from 'react';
import './detailBoxJob.css';
import { iconMapping } from '../../../../utils/icons'; // Import icon mapping

const DetailBoxJob = ({ title, data, id }) => {
  if (!data || typeof data !== 'object') {
    return null;
  }
  
  const formatKey = (key) => {
    return key
      .replace(/([A-Z])/g, ' $1') 
      .replace(/^./, (str) => str.toUpperCase()); 
  };

  return (
    <div className="detail-box-job__container" id={id}>
      <h3>{title}</h3>
      <ul>
        {Object.entries(data).map(([key, value]) => (
          <li key={key} className="detail-box-job__icon-info-container">
            <div className="detail-box-job__icon-container">
              {iconMapping[key] || iconMapping['default']} 
            </div>
            <div className='detail-box-job__icon-label-container'>
              <strong>{formatKey(key)}</strong>: 
              <p>{typeof value === 'boolean' ? (value ? 'Sí' : 'No') : value}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DetailBoxJob;
